<template>
  <div class="Buscar">
    <Menu :sesion="sesion" :url="url" v-if="sesion" />
    <Submenu :menuActivo="2" :url="url" />

    <div class="container-fluid pt-3">

        <router-link to="/Proyectos" class="notLink pt-5">
            <font-icon icon="arrow-circle-left"/> Regresar
        </router-link>

        <div class="row">
            <div class="col-sm-8">
                <h2 class="pt-3"> Propuestas para el proyecto: {{nombre}}</h2>
            </div>
            <div class="col-sm-4">
                <p class="float-right">
                    Imprimir Comparativo:
                    <button class="btn">
                        <font-icon style="font-size: 25px" icon="print" @click="imprimir()" />
                    </button>
                </p>
            </div>
        </div>
        <hr>

        <!--Spinner-->
        <div class="d-flex justify-content-center mt-5" v-if="status == true">
            <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
            </div>
        </div>

        <!--Listado de Propuestas-->
        <div v-else>

            <div class="row">
                <div class="col-sm-10"></div>
                <div class="col-sm-2">
                    <select class="form-control" @change="getData(ordenamiento)" v-model="ordenamiento">
                        <option value="">Ordenar Por:</option>
                        <option value="1">Mayor Precio</option>
                        <option value="0">Meno Precio</option>
                    </select>
                </div>
            </div>

            <div class="card mt-3"  v-if="dataPropuesta==null">
                <div class="card-body">
                    <p class="text-center">Sin Propuestas para este projecto.</p>
                </div>
            </div>

            <div v-else class="card mt-3" v-for="f in dataPropuesta" :key="f.id" :class="f.reoferta == '1' ? 'table-warning2' : ''">
                <div class="card-body">
                    <p class="mb-1 text-success" v-if="f.id_consultor == asignadoA && f.reoferta == '0'"><i> Adjudicado </i></p>
                    <table class="table" :class="f.reoferta == '1' ? 'table-warning2' : ''">
                        <thead>
                            <tr>
                                <th scope="col">Ofertante</th>
                                <th></th>
                                <th scope="col">Pais</th>
                                <th scope="col" class="text-center">Archivo</th>
                                <th scope="col">Fecha Ejecucion</th>
                                <th scope="col">Fecha Entrega</th>
                                <th scope="col">Vigencia</th>
                                <th scope="col">Monto</th>
                                <th scope="col">Concesiones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <img :src="getUrl(f.avatar)" class="img">
                                </td>
                                <td>
                                    <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                        @{{f.usuario}}
                                    </router-link><br>
                                    <star-rating :increment="0.5" :rating="makeNumber(f.estrellas)" :star-size="20"
                                    :show-rating="false" :read-only="true"/>
                                </td>
                                <td>
                                    <img :src="getBandera(f.pais_region)" class="bandera">
                                </td>
                                <td>
                                    <p class="text-center pointer" v-if="f.adjuntoOriginalOferta.length > 0">
                                        <font-icon icon="file-pdf" class="pdf" style="font-size:28px" @click="descargarFile(f.adjuntoOriginalOferta)"/>
                                    </p>
                                    <p v-else>
                                        Sin Adjunto
                                    </p>
                                </td>
                                <td> {{ fechaFormat(f.fecha_iniciop) }} </td>
                                <td> {{ fechaFormat(f.fecha_termino) }} </td>
                                <td> {{ fechaFormat(f.vigencia) }}  </td>
                                <td>
                                    ${{ moneda(f.costo) }}  <small>USD</small> <br>
                                    <span class="badge badge-warning mb-2" v-if="f.reoferta == '1'">
                                        En re-oferta
                                    </span>
                                    <span class="badge badge-primary mb-2" v-if="f.reoferta == '0' && f.reofertado == 1">
                                        Nueva oferta
                                    </span>
                                </td>
                                <td>
                                    <button class="btn orange btn-sm" @click="regChat(f.id_consultor,f.id_proyecto)">
                                        <font-icon icon="comments"/>
                                    </button>

                                    <button type="button" class="btn btn-sm btn-success" v-if="f.status_proyecto < 3" @click="asignar(f)" :disabled="f.reoferta == '1'">
                                        Adjudicar
                                    </button>

                                    <button type="button" class="btn btn-sm btn-secondary"  @click="Conceder(f)" v-if="f.estatus_oferta == 1" :disabled="f.reofertado > 0">
                                        Re-ofertar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h6>
                       <b>Mis fortalezas para ejecutar este proyecto son:</b>
                    </h6>

                    <div style="border: 1px solid #e9ecef; height: 40px; border-radius: 10px;" >
                        <p class="m-2">
                            {{f.notaPropuesta}}
                        </p>
                    </div>

                </div>
            </div>
        </div>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import Submenu from "@/components/Submenu";
import Menu from "@/components/Menu";
import StarRating from 'vue-star-rating'
import $ from 'jquery'

export default {
name: "Buscar",
components: {Submenu,Menu,StarRating},
mixins: [ globalFunctions ],
data() {
  return {
    sesion: false,
    status: false,
    rol: localStorage.rol,
    idProy: this.$route.params.idEmpresa,
    nombre: this.$route.params.nombre,
    dataPropuesta: [],
    statusAsignado: '',
    asignadoA: '',
    ordenamiento: ''
  };
},
methods: {
    getData(ord = 0) {

        let data = {
            id: this.idProy,
            flag:1,
            ord
        };

        this.axios.post(this.url + 'getPropuestas.php',data).then((responce) =>{
            this.dataPropuesta = responce.data;
            this.status = false;
        });

        data.flag = 2;

        this.axios.post(this.url + 'getPropuestas.php',data).then((responce) =>{
            this.asignadoA = responce.data[0].asignadaA;
        });

        this.status = true;
    },

    regChat(consultor, proyecto){

        let data = {
            flag: 0,
            idProyecto: proyecto,
            idEmpresa: localStorage.userID,
            idConsultor: consultor
        }
        
        this.axios.post(this.url + 'altaChat.php', data).then((responce) =>{
            if(responce.data == 200){
                $("#modalPropuestas").modal('hide');
                this.$router.push('/Blog?tabla=' + consultor + '&tabla2=' + proyecto);
            }
        })
    },
    asignar(f){
        let referencia = '0000';
        const d = new Date();
        let year = d.getFullYear();
        let month = d.getMonth();

        referencia = referencia + f.id_proyecto + f.id_consultor + month + year;

        let data = {
            idEmp: f.id_proyecto,
            idPropuesta: f.id_consultor,
            monto: f.costo,
            referencia
        }

        this.axios.post(this.url + 'altaAsignado.php', data).then((responce) =>{
            if(responce.data == 200){
                this.getData();
                this.enviarCorreo(5, 'Adjudicación de proyecto', f.id_proyecto);
                this.env
                this.$router.push('/Proyectos?tabla=3');
            }
        })
    },
    Conceder(f) {

        let data = {
            idoferta: f.id_oferta
        }

        this.axios.post(this.url + 'reofertar.php', data).then((responce) =>{

            var ord = 0;

            if(responce.data == 200){
                this.axios.post(this.url + 'getPropuestas.php',{ id: f.id_proyecto, flag:1, ord }).then((responce) =>{
                    this.msjOk("Se autorizo la reoferta del proyecto");
                    this.dataPropuesta = responce.data;
                    //this.sendEmail(4,f.email_princ, f.nombres, f.apellidos, f.id_proyecto);
                    this.enviarCorreo(4, 'Concesión de re-oferta', f.id_proyecto, f.id_user);
                });
            }
        });

    },

    imprimir(){
        alert("Proximamente")
    }
},
computed:{
    ...mapState(['url'])
},
mounted() {
  this.getData();

  let resp = this.checkUser();
  this.sesion = resp;
},
};
</script>


<style scoped>
.table-warning2{
    background-color: #eee4b0;
}
</style>



// WEBPACK FOOTER //
// src/views/Propuestas/Propuestas.vue